var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("FormBuilder", {
    key: _vm.formVersion,
    attrs: {
      initial: _vm.form,
      form: _vm.formDescription,
      validate: _vm.validate
    },
    on: { submit: _vm.submit },
    scopedSlots: _vm._u([
      {
        key: "donorSelector",
        fn: function({ value, listeners, values }) {
          return [
            _c(
              "Box",
              [
                _c(
                  "DonorLookup",
                  _vm._g(
                    { staticClass: "donor-lookup", attrs: { value: value } },
                    listeners
                  )
                ),
                _c(
                  "layoutText",
                  {
                    staticClass: "household-address",
                    attrs: { color: "#999", "font-size": "1" }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          values.selectedDonor
                            ? _vm.formatAddress(values.selectedDonor.address)
                            : ""
                        ) +
                        " "
                    )
                  ]
                )
              ],
              1
            )
          ]
        }
      },
      {
        key: "default",
        fn: function({
          donorSelector,
          info,
          details,
          applications,
          receipt,
          dafInfo,
          cardInfo,
          $values,
          matchingGiftInfo,
          iraInfo
        }) {
          return [
            _c(
              "Box",
              { staticClass: "payment" },
              [
                !_vm.pledgeId && !_vm.hideDonor
                  ? _c(
                      "Card",
                      [
                        _c(
                          "FormSection",
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v("Donor")
                            ]),
                            _c(
                              "template",
                              { slot: "main" },
                              [_c(donorSelector, { tag: "component" })],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "Card",
                  [
                    _c(
                      "FormSection",
                      [
                        _c("template", { slot: "header" }, [
                          _vm._v("Payment Info")
                        ]),
                        _c(
                          "template",
                          { slot: "main" },
                          [_c(info, { tag: "component" })],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                ),
                $values.type === "ChargeCard"
                  ? _c(
                      "Card",
                      [
                        _c(
                          "FormSection",
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v("Enter CC info")
                            ]),
                            _c(
                              "template",
                              { slot: "main" },
                              [
                                _c("span", [
                                  _vm._v(
                                    "Credit Charges will not show up until they're fully processed"
                                  )
                                ]),
                                _c("br"),
                                _c("br"),
                                _c(cardInfo, { tag: "component" })
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                $values.category === _vm.PaymentCategory.DAF
                  ? _c(
                      "Card",
                      [
                        _c(
                          "FormSection",
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v("Donor Advised Fund")
                            ]),
                            _c(
                              "template",
                              { slot: "main" },
                              [_c(dafInfo, { tag: "component" })],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                $values.category === _vm.PaymentCategory.IRA
                  ? _c(
                      "Card",
                      [
                        _c(
                          "FormSection",
                          [
                            _c("template", { slot: "header" }, [_vm._v("IRA")]),
                            _c(
                              "template",
                              { slot: "main" },
                              [_c(iraInfo, { tag: "component" })],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                $values.category === _vm.PaymentCategory.MatchingGift
                  ? _c(
                      "Card",
                      [
                        _c(
                          "FormSection",
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v("MatchingGift")
                            ]),
                            _c(
                              "template",
                              { slot: "main" },
                              [_c(matchingGiftInfo, { tag: "component" })],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "Card",
                  [
                    _c(
                      "FormSection",
                      [
                        _c("template", { slot: "header" }, [_vm._v("Receipt")]),
                        _c(
                          "template",
                          { slot: "main" },
                          [_c(receipt, { tag: "component" })],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "Card",
                  [
                    _c(
                      "FormSection",
                      [
                        _c("template", { slot: "header" }, [
                          _vm._v("Payment Details")
                        ]),
                        _c(
                          "template",
                          { slot: "main" },
                          [_c(details, { tag: "component" })],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                ),
                !_vm.pledgeId && $values.selectedDonor
                  ? _c(
                      "Box",
                      { staticClass: "pledges-card nopadding" },
                      [
                        _c(applications, {
                          key: $values.selectedDonor.id,
                          tag: "component"
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "UIButton",
                  {
                    staticClass: "submit-btn",
                    attrs: { disabled: _vm.processing }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.processing ? "Submitting" : "Submit") +
                        " "
                    )
                  ]
                )
              ],
              1
            )
          ]
        }
      },
      {
        key: "amount-value",
        fn: function({ listeners, value, values }) {
          return [
            _c(
              "AmountWithCurrencyField",
              _vm._g(
                _vm._b(
                  {
                    attrs: {
                      date: values.date
                        ? _vm.monthDayYearToDate(values.date)
                        : null,
                      convertedAmount: values.convertedAmount,
                      isCurrencyChangeable: !_vm.pledgeCurrency,
                      errorStr: _vm.amountError
                    }
                  },
                  "AmountWithCurrencyField",
                  { value },
                  false
                ),
                listeners
              )
            )
          ]
        }
      },
      {
        key: "applications",
        fn: function({ listeners, values }) {
          return [
            _c(
              "PledgeSelector",
              _vm._g(
                {
                  attrs: {
                    donorId: values.selectedDonor && values.selectedDonor.id,
                    amount: values.amount
                      ? parseFloat(values.amount.amount)
                      : 0,
                    currency: values.amount
                      ? values.amount.currency
                      : undefined,
                    errorStr: _vm.appError,
                    date: values.date ? values.date : undefined
                  }
                },
                listeners
              )
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }